import { combineEpics } from 'redux-observable';
import { of } from 'rxjs';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/filter';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/switchMap';

import { organizationGuidSel } from '@shared/duck/selectors/general.selectors';
import '@utils/rxjs.add.operator.catchAndReport';

import {
  UNIT_INFO_REQUEST,
  UNIT_INFO_REQUEST_IF_NOT_LOADED,
  UNIT_PROFILE_REQUEST,
  unitInfoError,
  unitInfoRequest,
  unitInfoResponse,
  unitProfileError,
  unitProfileResponse,
} from './actions';
import { unitInfoLoadingSel, unitInfoSel } from './selectors';
import services from './services';

const fetchUnitProfile$ = (action$, _state$, { store }) =>
  action$
    .ofType(UNIT_PROFILE_REQUEST)
    .mergeMap(action => {
      const [orgGuid] = action.payload.organizationGuid.split('*');
      return services.getUnitInfo$(orgGuid, store.dispatch);
    })
    .mergeMap(response => Observable.concat(of(unitProfileResponse(response))))
    .catchAndReport(err => Observable.of(unitProfileError(err)));

const fetchUnitInfoIfNotLoaded$ = (action$, state$) =>
  action$
    .ofType(UNIT_INFO_REQUEST_IF_NOT_LOADED)
    .filter(() => !unitInfoLoadingSel(state$.value))
    .filter(() => {
      const unitInfoLoaded =
        Object.keys(unitInfoSel(state$.value)).length !== 0;
      return !unitInfoLoaded;
    })
    .map(unitInfoRequest);

const fetchUnitInfo$ = (action$, state$, { store }) =>
  action$
    .ofType(UNIT_INFO_REQUEST)
    .switchMap(() => {
      const guid = organizationGuidSel(state$.value);
      if (!guid)
        return Observable.of(
          unitInfoError({ message: 'Invalid organization' }),
        );
      return services.getUnitInfo$(guid, store.dispatch);
    })
    .map(unitInfoResponse)
    .catchAndReport(err => Observable.of(unitInfoError(err)));

export default combineEpics(
  fetchUnitInfoIfNotLoaded$,
  fetchUnitInfo$,
  fetchUnitProfile$,
);
